export default {
    props: {
        schemaAggregates: {
            type: Function | String,
            kComposite: 'schema.aggregates'
        },
        schemaData: {
            type: Function | String,
            kComposite: 'schema.data'
        },
        schemaErrors: {
            type: Function | String,
            kComposite: 'schema.errors'
        },
        schemaGroups: {
            type: Function | String,
            kComposite: 'schema.groups'
        },
        schemaModel: {
            type: Object | kendo.data.Model,
            kComposite: 'schema.model'
        },
        schemaModelId: {
            type: String,
            kComposite: 'schema.model.id'
        },
        schemaModelFields: {
            type: Object,
            kComposite: 'schema.model.fields'
        },
        schemaParse: {
            type: Function,
            kComposite: 'schema.parse'
        },
        schemaTotal: {
            type: Function | String,
            kComposite: 'schema.total'
        },
        schemaType: {
            type: String,
            kComposite: 'schema.type'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/Schema.js